import { render, staticRenderFns } from "./TotalQualitativo.vue?vue&type=template&id=7d24a7ce"
import script from "./TotalQualitativo.vue?vue&type=script&lang=ts"
export * from "./TotalQualitativo.vue?vue&type=script&lang=ts"
import style0 from "./TotalQualitativo.vue?vue&type=style&index=0&id=7d24a7ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports